import { space } from '../tokens';
import { iconButton } from '../button/icon-button.css';
import { globalStyle, style } from '../layer.css';

export const inputIconButton = style([
  iconButton,
  {
    padding: space.s6,
    margin: -space.s6,
  },
]);

globalStyle(`${inputIconButton} :where(svg)`, {
  width: 20,
  height: 20,
});
